module.exports = __webpack_public_path__ + "img/support.7d30c985.png";